const searchResultsFilterAppliedFilter = (state = false, action) => {
  if (action.type === "APPLY_SEARCH_RESULTS_FILTER") {
      state = action.applyFilter;
  } else if (action.type === 'UPDATE_SEARCH_RESULTS' || action.type === 'LOGOUT_USER') {
      state = false;
  }
  return state;
}

export default searchResultsFilterAppliedFilter;